<template>
  <div>
    <div class="order-title"></div>
    <mu-container>
      <mu-form
        :model="form"
        class="mu-demo-form"
        label-position="right"
        label-width="80"
      >
        <div class="form-item form-item-subject">
          <div v-if="currentSubject" class="img-aspect-fit-warp img-wrap">
            <img
              class="cover"
              :src="'http://edu.dxxf119.cn/' + currentSubject.pic"
            />
          </div>
          <mu-form-item prop="select">
            <mu-select
              v-model="form.subject_id"
              :label="form.subject_id ? '' : '选择课程'"
              @change="courseCenterChange"
            >
              <mu-option
                v-for="(option, index) in courseCenterList"
                :key="index"
                :label="option.title"
                :value="option.id"
              ></mu-option>
            </mu-select>
          </mu-form-item>
        </div>

        <div v-show="currentTypeList.length > 0" class="form-item">
          <div class="head">
            <span class="material-icons icon">
              dashboard
            </span>
            <span class="text">类别</span>
          </div>

          <mu-form-item prop="type" label="类别">
            <mu-radio
              v-for="(item, index) in currentTypeList"
              :key="index"
              v-model="form.type"
              :value="item.value"
              :label="item.label"
              color="#214ecf"
              @change="typeChange"
            ></mu-radio>
          </mu-form-item>
        </div>

        <div v-show="serviceLife.length > 0" class="form-item">
          <div class="head">
            <span class="material-icons icon">
              date_range
            </span>
            <span class="text">使用期限</span>
          </div>

          <mu-form-item prop="serviceLife" label="使用期限">
            <mu-radio
              v-for="(item, index) in serviceLife"
              :key="index"
              v-model="form.buy_time_id"
              :value="item.id"
              :label="item.buy_time + '天'"
              color="#214ecf"
              @change="serviceLifeChange(index)"
            ></mu-radio>
          </mu-form-item>
        </div>
      </mu-form>

      <mu-dialog title="填写身份信息" width="360" :open.sync="dialogShowing">
        <mu-form :model="form" label-position="right" label-width="80">
          <mu-form-item prop="input" label="姓名">
            <mu-text-field v-model="form.name"></mu-text-field>
          </mu-form-item>
          <mu-form-item prop="input" label="身份证号">
            <mu-text-field v-model="form.idcard"></mu-text-field>
          </mu-form-item>
        </mu-form>
        <mu-button slot="actions" flat color="primary" @click="confirmIDCard">
          确定
        </mu-button>
      </mu-dialog>

      <mu-flex
        class="bar-btm"
        style="position: fixed; bottom: 0; left: 0; right: 0; height: 48px;"
        justify-content="center"
        align-items="center"
      >
        <div class="price">
          价格
          <span style="color: #214ecf; font-size: 1.3em; font-weight: bold;">
            {{ currentPrice }}元
          </span>
        </div>
        <mu-snackbar
          :open.sync="snack.open"
          :message="snack.msg"
          position="bottom"
          color="error"
        />
        <mu-button
          :disabled="!allowPayment || paying"
          color="#214ecf"
          style="width: 120px; height: 100%; border-radius: 0;"
          @click="submit"
        >
          去付款
        </mu-button>
      </mu-flex>
    </mu-container>
  </div>
</template>

<script>
import {
  fetchCourseCenter,
  fetchOrderGetPayInfo,
  fetchOrderGenerate,
  fetchHasIDCard,
} from '@/api/index'
export default {
  components: {},
  data() {
    return {
      dialogShowing: false,
      snack: {
        open: false,
        msg: '',
      },
      courseCenterList: [],
      serviceLife: [],
      form: {
        subject_id: '',
        type: '',
        buy_time_id: '',
        idcard: '',
      },
      price: -1,
      current_hasCourses: '',
      IDCard: '',
      paying: false,
    }
  },
  computed: {
    allowPayment() {
      return this.currentPrice > 0
    },
    currentPrice() {
      return this.price >= 0 ? this.price : '--'
    },
    currentTypeList() {
      const result = []
      if (this.current_hasCourses.indexOf(1) >= 0) {
        result.push({
          label: '课程资料',
          value: 1,
        })
      }
      if (this.current_hasCourses.indexOf(2) >= 0) {
        result.push({
          label: '章节练习/模拟考试',
          value: 2,
        })
      }
      if (result.length === 2) {
        result.push({
          label: '课程报名(包含课程资料/练习/考试)',
          value: 3,
        })
      }
      return result
    },
    currentSubject() {
      return (
        this.courseCenterList.find((e) => e.id === this.form.subject_id) ||
        false
      )
    },
  },
  watch: {},
  created() {
    this.getIDCard()
    this.fetchCourseCenter().then(() => this.handlePresetQuery())
  },
  mounted() {},
  methods: {
    IdentityCodeValid(code) {
      var city = {
        11: '北京',
        12: '天津',
        13: '河北',
        14: '山西',
        15: '内蒙古',
        21: '辽宁',
        22: '吉林',
        23: '黑龙江 ',
        31: '上海',
        32: '江苏',
        33: '浙江',
        34: '安徽',
        35: '福建',
        36: '江西',
        37: '山东',
        41: '河南',
        42: '湖北 ',
        43: '湖南',
        44: '广东',
        45: '广西',
        46: '海南',
        50: '重庆',
        51: '四川',
        52: '贵州',
        53: '云南',
        54: '西藏 ',
        61: '陕西',
        62: '甘肃',
        63: '青海',
        64: '宁夏',
        65: '新疆',
        71: '台湾',
        81: '香港',
        82: '澳门',
        91: '国外 ',
      }
      var tip = ''
      var pass = true

      if (
        !code ||
        !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i.test(
          code
        )
      ) {
        tip = '身份证号格式错误'
        pass = false
      } else if (!city[code.substr(0, 2)]) {
        tip = '地址编码错误'
        pass = false
      } else {
        //18位身份证需要验证最后一位校验位
        if (code.length == 18) {
          code = code.split('')
          //∑(ai×Wi)(mod 11)
          //加权因子
          var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
          //校验位
          var parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2]
          var sum = 0
          var ai = 0
          var wi = 0
          for (var i = 0; i < 17; i++) {
            ai = code[i]
            wi = factor[i]
            sum += ai * wi
          }
          // var last = parity[sum % 11]
          if (parity[sum % 11] != code[17]) {
            tip = '校验位错误'
            pass = false
          }
        }
      }
      if (!pass) {
        this.snack.msg = tip
        this.snack.open = true
        setTimeout(() => {
          this.snack.open = false
        }, 1500)
        return false
      }
      return pass
    },
    getIDCard() {
      fetchHasIDCard().then((res) => {
        this.IDCard = res.idcard
      })
    },
    handlePresetQuery() {
      const query = this.$route.query
      if (query.subject_id) {
        this.form.subject_id = Number(query.subject_id)
        this.courseCenterChange(this.form.subject_id)
      }
    },
    submit() {
      if (!this.form.subject_id) {
        this.snack.msg = '请选择课程'
      } else if (!this.form.type) {
        this.snack.msg = '请选择类别'
      } else if (!this.form.buy_time_id) {
        this.snack.msg = '请选择使用期限'
      } else {
        this.snack.msg = ''
      }
      if (this.snack.msg !== '') {
        this.snack.open = true
        setTimeout(() => {
          this.snack.open = false
        }, 1500)
        return
      }

      if (this.form.type === 3 && !this.IDCard) {
        this.dialogShowing = true
        return
      }
      this.goPay()
    },
    confirmIDCard() {
      if (!this.IdentityCodeValid(this.form.idcard)) return
      this.dialogShowing = false
      this.goPay()
    },
    goPay() {
      this.paying = true
      const title = this.courseCenterList.find(
        (e) => e.id === this.form.subject_id
      ).title
      const params = {
        title,
        info: [
          {
            subject_id: this.form.subject_id,
            buy_time_id: this.form.buy_time_id,
            type: this.form.type,
          },
        ],
      }
      if (!this.IDCard) {
        params.name = this.form.name
        params.idcard = this.form.idcard
      }
      fetchOrderGenerate(params)
        .then((res) => {
          console.log('fetchOrderPay', res)
          this.getBrandWXPayRequest(res)
            .then((WXPayRes) => {
              console.log('getBrandWXPayRequest', WXPayRes)
              this.$NewToast.success('支付成功')
              setTimeout(() => this.$router.back(), 1000)
            })
            .catch((err) => {
              this.$NewToast.error('支付失败:' + err.errMsg)
            })
        })
        .finally(() => (this.paying = false))
    },
    getBrandWXPayRequest(payInfo) {
      console.log(payInfo)
      return new Promise((resolve, reject) => {
        function onBridgeReady() {
          WeixinJSBridge.invoke('getBrandWCPayRequest', payInfo, function (
            res
          ) {
            if (res.err_msg == 'get_brand_wcpay_request:ok') {
              // 使用以上方式判断前端返回,微信团队郑重提示：
              // res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
              resolve()
            } else if (res.err_msg == 'get_brand_wcpay_request:fail') {
              reject(res)
            }
          })
        }

        if (typeof WeixinJSBridge == 'undefined') {
          if (document.addEventListener) {
            document.addEventListener(
              'WeixinJSBridgeReady',
              onBridgeReady,
              false
            )
          } else if (document.attachEvent) {
            document.attachEvent('WeixinJSBridgeReady', onBridgeReady)
            document.attachEvent('onWeixinJSBridgeReady', onBridgeReady)
          }
        } else {
          onBridgeReady()
        }
      })
    },
    courseCenterChange(e) {
      this.current_hasCourses = this.courseCenterList.find(
        (item) => item.id === e
      ).has_courses

      this.buy_time_id = ''
      this.price = -1
      this.form.type = ''
      this.serviceLife = 0
      if (this.form.subject_id && this.form.type) {
        this.fetchOrderGetPayInfo({
          subject_id: this.form.subject_id,
          type: this.form.type,
        })
      }
    },
    typeChange() {
      this.form.buy_time_id = ''
      this.price = -1
      if (this.form.subject_id && this.form.type) {
        this.fetchOrderGetPayInfo({
          subject_id: this.form.subject_id,
          type: this.form.type,
        })
      }
    },
    serviceLifeChange(index) {
      this.price = this.serviceLife[index].price
    },
    async fetchOrderGetPayInfo(params) {
      const data = await fetchOrderGetPayInfo(params)
      this.serviceLife = data
    },
    async fetchCourseCenter() {
      const data = await fetchCourseCenter()
      this.courseCenterList = data.filter(
        (item) => item.has_courses != '' && item.is_open === 1
      )
    },
  },
}
</script>

<style lang="scss" scoped>
// 题库标题
.order-title {
  width: 100vw;
  height: 90px;
  background-color: #214ecf;
  background-image: linear-gradient(-72deg, #214ecf 0%, #de774f 100%);
}

.mu-demo-form {
  position: relative;
  top: -30px;
  padding: 0 8px;
}

.form-item {
  padding: 12px 14px;
  background-color: #ffffff;
  box-shadow: 0px 0px 18px 1px rgba(3, 0, 1, 0.1);
  border-radius: 5px;

  + .form-item {
    margin-top: 12px;
  }

  &.form-item-subject {
    display: flex;
    align-items: center;
    .mu-form-item {
      flex: 1;
      margin-left: 20px;
    }
  }

  .img-wrap {
    height: 58px;
    width: 44px;
  }

  .head {
    display: flex;
    align-items: center;
    .icon {
      font-size: 12px;
      color: #214ecf;
      border: solid 1px #d0021b;
      border-radius: 50px;
      padding: 2px;
      margin-right: 6px;
    }
    .text {
      font-size: 18px;
      font-weight: bold;
    }
  }
}
.mu-demo-form {
  ::v-deep .mu-form-item {
    margin-bottom: 0;
    padding: 0;
    min-height: auto;
  }
  ::v-deep .mu-form-item-label {
    display: none;
  }

  ::v-deep .mu-radio {
    width: 100%;
    height: auto;
    padding-top: 8px;
    padding-bottom: 12px;
    border-bottom: solid 1px #eeeeee;
  }
  ::v-deep .mu-form-item-content {
    flex-direction: column;
  }
  ::v-deep .mu-radio-wrapper {
    flex-direction: row-reverse;
  }
  ::v-deep .mu-radio-label {
    color: #666666;
  }
  ::v-deep .mu-input-line {
    display: none;
  }
  ::v-deep .mu-input-focus-line {
    display: none;
  }
  ::v-deep .mu-radio-icon {
    transform: scale(0.8);
  }
  ::v-deep .mu-select-input {
    font-weight: bold;
    font-size: 16px;
  }
  ::v-deep .mu-form-item-content {
    padding-left: 4px;
  }
  ::v-deep .mu-radio-icon-uncheck {
    color: #aaa;
  }
  ::v-deep .mu-input-label {
    font-weight: bold;
    font-size: 20px;
  }
  ::v-deep .mu-input__focus {
    color: rgba(0, 0, 0, 0.54);
  }
}

.bar-btm {
  box-shadow: 0px 0px 9px 1px rgba(7, 0, 2, 0.16);

  .price {
    flex: 1;
    padding-left: 20px;
  }
}
</style>
